var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"click-to-run mb-2",attrs:{"role":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('BIconPlayCircleFill'),_c('span',{staticClass:"ml-1"},[_vm._v("点击启动游戏")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }